import { onBeforeUnmount, shallowRef, toValue, watch } from 'vue'
import { chartEditSession } from '@/components/templateStudio/charts/chartEditing.js'

/**
 * RED-317 PR 3d-A — the chart an editor is editing inline, as a ref the
 * canvas renders StudioChartEditor from: null, or { controller, id }. The
 * Studio schema keeps its session in a plain observable (no Vue in the
 * extensions); this mirrors it for the editor `editorSource` currently is.
 */
export function useChartEditSession(editorSource) {
  const session = shallowRef(null)
  let unsubscribe = null
  let serial = 0

  const follow = (editor) => {
    unsubscribe?.()
    unsubscribe = null
    session.value = null
    if (!editor) return
    const cell = chartEditSession(editor)
    const mirror = (value) => {
      session.value = value ? { controller: value.controller, id: ++serial } : null
    }
    mirror(cell.value)
    unsubscribe = cell.subscribe(mirror)
  }

  watch(() => toValue(editorSource), follow, { immediate: true })
  onBeforeUnmount(() => unsubscribe?.())

  return session
}
